import { render, staticRenderFns } from "./orderRelease.vue?vue&type=template&id=7539d165&scoped=true"
import script from "./orderRelease.vue?vue&type=script&lang=js"
export * from "./orderRelease.vue?vue&type=script&lang=js"
import style0 from "./orderRelease.vue?vue&type=style&index=0&id=7539d165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539d165",
  null
  
)

export default component.exports